module.exports = __webpack_public_path__ + "img/share.60d3f77d.svg";